import React, { useEffect, useState } from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import shape4 from "../../../assets/images/resource/portfolio-bg.png";
import two from "../../../assets/images/resource/portfolio-01.jpg";
import two2 from "../../../assets/images/resource/portfolio-02.png";
import two3 from "../../../assets/images/resource/portfolio-03.png";
import two4 from "../../../assets/images/resource/portfolio-04.png";
import { Link } from 'react-router-dom';
import { fetchProjects } from '../../../DataFetchers/fetchProjects';

const Portfolio = () => {

    const [projectData, setProjectData] = useState([]);

    useEffect(() => {
        fetchProjects().then((data) => {
                setProjectData(data);
            })
    }, []);

    return (

        <section className="portfolio  p_relative">
            <div className="portfolio-layer p_absolute" style={{ backgroundImage: `url(${shape4})` }}></div>
            <div className="auto-container">
                <div className="title__data">
                    <div className="sub__title">
                        <h4><br/>Project Examples </h4>
                    </div>
                    {/* <div className="title">
                        <h2>Some Of Our Projects</h2>
                    </div> */}
                </div>
                <div className="protfolio__inner">
                    <OwlCarousel
                        key={projectData.length}
                        className="portfolio-carousel owl-theme owl-carousel owl-dots-none"
                        items={4}
                        loop={true}
                        margin={24}
                        smartSpeed={1000}
                        autoplay={6000}
                        responsive={{
                            0: {
                                items: 1,
                            },
                            600: {
                                items: 2,
                            },
                            768: {
                                items: 3,
                            },
                            992: {
                                items: 3,
                            },
                            1200: {
                                items: 4,
                            },
                        }}
                    >
                        {projectData.map((item, id) => (<div className="portfolio__block p_relative" key={id}>
                            <div className="portfolio__image">
                                <figure>
                                    <div />
                                </figure>
                            </div>
                            <div className="home__lower__content p_absolute">
                                <div className="protfolio__text">
                                    <div className="text__block">
                                        <h4>{item.name}</h4>
                                        <p>{item.type}</p>
                                    </div>
                                </div>
                                {item.readMore && <div className="protfolio__button">
                                    <Link to={`/projects-details?project=${encodeURIComponent(item.name)}`}
                                        className="theme-btn theme-btn-one"> Read More<i className="icon-02"></i></Link>
                                </div>}
                            </div>
                        </div>))}
                    </OwlCarousel>
                </div>
            </div>
        </section>
    );
};

export default Portfolio;
